import { useLocation, useNavigate } from 'react-router'

import { pages } from '~/app/routes'
import { AstraTabs } from '~/astra'
import { PageTitleBar } from '~/components'

import { useEnabledHospitalConfigurationViews } from '../HospitalConfiguration.page'

export const TitleBar = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const viewDescriptors = useEnabledHospitalConfigurationViews()

    const options = viewDescriptors.map(descriptor => ({
        label: descriptor.view.title,
        value: descriptor.view.path,
        content: null,
    }))

    return (
        <PageTitleBar
            title={pages.HOSPITAL_CONFIGURATION.title}
            viewSwitcher={<AstraTabs options={options} onValueChange={path => navigate(path)} value={pathname} noPadding noSeparatorLine highContrast />}
        />
    )
}
